<template>
  <v-dialog
    v-model="showDialog"
    max-width="520"
    persistent
    scrollable
    content-class="announcement-dialog"
  >
    <v-card class="announcement-card" elevation="0">
      <div class="announcement-hero">
        <div class="announcement-icon-wrap">
          <v-icon color="white" size="28">mdi-clipboard-check-outline</v-icon>
        </div>
        <div class="announcement-eyebrow">Informasi</div>
        <h2 class="announcement-title">Review Kompetensi</h2>
      </div>

      <v-card-text class="announcement-body">
        <p class="announcement-lead">
          Proses penilaian terstruktur untuk mengukur kemampuan, keterampilan,
          pengetahuan, dan perilaku dalam menjalankan tugas tertentu. Proses ini membandingkan kemampuan aktual pekerja dengan standar kompetensi yang dibutuhkan oleh organisasi.
        </p>

        <div class="announcement-note">
          <div class="announcement-note-header">
            <v-icon small color="accent" class="mr-2">mdi-information-outline</v-icon>
            <span>Perlu diketahui</span>
          </div>
          <ul class="announcement-note-list">
            <li>Tidak mempengaruhi besaran TPP yang akan diterima</li>
            <li>Untuk sementara hanya ditujukan kepada pegawai Jabatan Fungsional Umum</li>
            <li>Pilih pernyataan perilaku yang benar-benar menggambarkan diri Anda</li>
          </ul>
        </div>
      </v-card-text>

      <v-card-actions class="announcement-actions">
        <v-btn
          block
          large
          color="primary"
          dark
          class="announcement-cta"
          @click="redirectTo"
        >
          Mengerti
          <v-icon right small>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store'
import KuesionerService from '@/services/KuesionerService'

export default {
  name: 'Announcement',
  data () {
    return {
      showDialog: false
    }
  },
  created () {
    const { year } = store.state.user.current
    if (year >= 2026) {
      this.fetchStatus()
    }
  },
  methods: {
    fetchStatus () {
      KuesionerService.getKompetensiStatus()
        .then(res => {
          this.showDialog = !!(res.data && res.data.data && res.data.data.is_show_info)
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    redirectTo () {
      this.$router.push('/review-kompetensi')
    }
  }
}
</script>

<style lang="scss" scoped>
.announcement-card {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
  border-radius: 16px !important;
  background: #fff;
}

.announcement-hero {
  position: relative;
  flex-shrink: 0;
  padding: 28px 28px 24px;
  background:
    radial-gradient(ellipse at 100% 0%, rgba(0, 188, 212, 0.22), transparent 55%),
    linear-gradient(145deg, #003247 0%, #004159 55%, #0a5a72 100%);
  color: #fff;
  text-align: center;
}

.announcement-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(6px);
}

.announcement-eyebrow {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
}

.announcement-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.announcement-body {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 24px 28px 8px !important;
}

.announcement-lead {
  margin: 0 0 20px;
  font-size: 0.95rem;
  line-height: 1.65;
  color: rgba(0, 65, 89, 0.82);
}

.announcement-note {
  padding: 16px 18px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7fbfd 0%, #f2f8fa 100%);
  border: 1px solid rgba(0, 65, 89, 0.08);
}

.announcement-note-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #004159;
}

.announcement-note-list {
  margin: 0;
  padding-left: 18px;
  color: rgba(0, 65, 89, 0.78);
  font-size: 0.875rem;
  line-height: 1.55;

  li + li {
    margin-top: 6px;
  }
}

.announcement-actions {
  flex-shrink: 0;
  padding: 8px 28px 28px !important;
}

.announcement-cta {
  letter-spacing: 0.03em;
  font-weight: 600;
  border-radius: 10px !important;
  text-transform: none;
  box-shadow: 0 8px 20px rgba(0, 65, 89, 0.22) !important;
}
</style>

<style lang="scss">
.announcement-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 33, 48, 0.28) !important;
}
</style>
